export default "__VITE_ASSET__e5587b25__"